import { useQuery } from '@mint-lib/query-client';
import { useService } from '@mint-lib/routing-context';
import { FiltersIntegrations } from '@mint-sdk/api-integrations';

import { FiltersOptions } from '../../types/common.js';
import { transformFiltersResponse } from '../../utils/filters.js';

export const useGetFilterList = () => {
  const [queryClient] = useService({
    name: 'queryClient',
    suspense: true,
  });

  const { data, isLoading, isFetching, isSuccess } = useQuery(
    {
      ...FiltersIntegrations.get({}),
      staleTime: 1000 * 60 * 5,
    },
    queryClient,
  );

  return {
    data: data ? transformFiltersResponse(data) : ({} as FiltersOptions),
    isSuccess,
    isLoading: isLoading || isFetching,
  };
};
